import { useState, useCallback } from 'react';
import api from '../api';

export function useAgent3() {
  const [agent3History, setAgent3History] = useState([]);
  const [agent3Status, setAgent3Status] = useState({ is_running: false, queue_size: 0, stats: {} });
  const [agent3Error, setAgent3Error] = useState(false);

  const fetchAgent3History = useCallback(async () => {
    setAgent3Error(false);
    try {
      const res = await api.get('/agent3/history');
      if (res.data) {
        setAgent3History(res.data.history || []);
        setAgent3Status(res.data.status || { is_running: false, queue_size: 0, stats: {} });
      }
    } catch (err) {
      console.warn("Erro ao buscar histórico do Agente 3:", err);
      setAgent3Error(true);
    }
  }, []);

  const startAgent3Queue = useCallback(async (limit = null) => {
    try {
      const res = await api.post('/admin/agent3/start', { limit });
      if (res.data && res.data.status === 'error') {
        alert(res.data.message);
        return;
      }
      await fetchAgent3History();
    } catch (err) {
      console.warn("Erro ao iniciar Agente 3:", err);
      alert("Erro ao iniciar a fila do Agente 3.");
    }
  }, [fetchAgent3History]);

  const stopAgent3Queue = useCallback(async () => {
    try {
      await api.post('/admin/agent3/stop');
      await fetchAgent3History();
    } catch (err) {
      console.warn("Erro ao parar Agente 3:", err);
      alert("Erro ao parar a fila do Agente 3.");
    }
  }, [fetchAgent3History]);

  return {
    agent3History,
    agent3Status,
    agent3Error,
    fetchAgent3History,
    startAgent3Queue,
    stopAgent3Queue
  };
}
